import i18next from 'i18next';
var I18N_NESTING_KEY_SEPARATOR = '$';
var DEFAULT_I18N_NS = 'translation';
export var initI18nLean = function (lng, localeData) {
    var _a, _b;
    var instance = i18next.createInstance();
    instance.init({
        keySeparator: I18N_NESTING_KEY_SEPARATOR,
        interpolation: {
            escapeValue: false,
            format: format,
        },
        resources: (_a = {}, _a[lng] = (_b = {}, _b[DEFAULT_I18N_NS] = localeData, _b), _a),
        lng: lng,
    });
    return instance;
};
function format(value, _format, _lng, options) {
    if (options === void 0) { options = {}; }
    switch (_format) {
        case 'number':
            return typeof options.numberFormatted === 'string' ? options.numberFormatted : value;
        default:
            return value;
    }
}
